// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import CommitmentQuestions from "../../components/questionnaires/commitmentQuestions";

const CommitmentQuestionsView = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <CommitmentQuestions />
    </Main>
  </>
);

export default CommitmentQuestionsView;
